// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .form-card {
    background: #fff;
    border-radius: 12px;
    padding: 20px 45px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  
  .form-section {
    margin-bottom: 24px;
    text-align: start;
  }
  
  .form-label-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .form-label {
    font-size: 15px;
    font-weight: 600;
    color: #5a5959;
    text-align: start;
  }

  .secret{
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    gap: 5px;
    
  }
  .secret label{
    font-size: 14px;
    font-weight: 500;
    color: #5a5959;
  }

  .warningtext{
    font-size: 12px;
    font-weight: 400;
    color: #6f6d6d; 
    margin: 10px 0px 20px 0px;
    text-align: start;
  }

  .file-upload {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;
    margin-bottom: 5px;
  }

  .file-upload:hover {
    border-color: #888;
  }

  .file-upload input {
    display: none;
  }

  .file-upload-text {
    display: block;
    font-size: 18px;
    color: #333;
  }

  .file-upload p {
    font-size: 13px;
    color: #888;
    margin-top: 8px;
  }
  
  .required {
    color: red;
    margin-left: 4px;
  }
  
  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .radio-option {
    display: flex;
    text-align: start;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    color: #555;
    cursor: pointer;
  }
  
  .radio-option input {
    margin-top: 4px;
  }
  
  .form-textarea, .form-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 14px;
    resize: none;
    transition: border-color 0.2s;
  }
  
  .form-textarea:focus, .form-input:focus {
    border-color: #007bff;
    outline: none;
  }
  .Toastify__toast-body {
    font-size: 14px; /* Энд хүссэн хэмжээ */
  }
  
  .input-icon-wrapper {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    height: 20px;
    width: 20px;
    color: #888;
  }
  
  .error {
    color: #e11d48;
    font-size: 13px;
    margin-top: 4px;
  }
  
  .error-border {
    border-color: #e11d48 !important;
  }
  
  .file-drop {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 40px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .file-drop:hover {
    border-color: #007bff;
    background: #f0f8ff;
  }
  
  .file-icon {
    height: 48px;
    width: 48px;
    color: #706e6e;
    margin-bottom: 10px;
  }
  
  .file-text {
    font-size: 15px;
    color: #444;
    margin-bottom: 4px;
  }
  
  .file-note {
    font-size: 12px;
    color: #777;
  }
  
  .file-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 12px 16px;
  }
  
  .file-details {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .file-small-icon {
    color: #007bff;
    height: 20px;
    width: 20px;
  }
  
  .file-name {
    font-weight: 600;
    color: #333;
  }
  
  .file-size {
    font-size: 13px;
    color: #666;
  }
  
  .file-remove {
    background: #fee2e2;
    border: none;
    border-radius: 50%;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .file-remove:hover {
    background: #fecaca;
  }
  
  .form-footer {
    border-top: 1px solid #eee;
    padding-top: 20px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/style/whistleForm.css"],"names":[],"mappings":";;EAEE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,QAAQ;;EAEV;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;EACA;IACE,eAAe,EAAE,sBAAsB;EACzC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB","sourcesContent":["\n  \n  .form-card {\n    background: #fff;\n    border-radius: 12px;\n    padding: 20px 45px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  }\n  \n  .form-section {\n    margin-bottom: 24px;\n    text-align: start;\n  }\n  \n  .form-label-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n  \n  .form-label {\n    font-size: 15px;\n    font-weight: 600;\n    color: #5a5959;\n    text-align: start;\n  }\n\n  .secret{\n    display: flex;\n    flex-direction: column;\n    margin-top: 5px;\n    gap: 5px;\n    \n  }\n  .secret label{\n    font-size: 14px;\n    font-weight: 500;\n    color: #5a5959;\n  }\n\n  .warningtext{\n    font-size: 12px;\n    font-weight: 400;\n    color: #6f6d6d; \n    margin: 10px 0px 20px 0px;\n    text-align: start;\n  }\n\n  .file-upload {\n    border: 2px dashed #ccc;\n    border-radius: 8px;\n    padding: 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: border-color 0.3s;\n    margin-bottom: 5px;\n  }\n\n  .file-upload:hover {\n    border-color: #888;\n  }\n\n  .file-upload input {\n    display: none;\n  }\n\n  .file-upload-text {\n    display: block;\n    font-size: 18px;\n    color: #333;\n  }\n\n  .file-upload p {\n    font-size: 13px;\n    color: #888;\n    margin-top: 8px;\n  }\n  \n  .required {\n    color: red;\n    margin-left: 4px;\n  }\n  \n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .radio-option {\n    display: flex;\n    text-align: start;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 14px;\n    color: #555;\n    cursor: pointer;\n  }\n  \n  .radio-option input {\n    margin-top: 4px;\n  }\n  \n  .form-textarea, .form-input {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    font-size: 14px;\n    resize: none;\n    transition: border-color 0.2s;\n  }\n  \n  .form-textarea:focus, .form-input:focus {\n    border-color: #007bff;\n    outline: none;\n  }\n  .Toastify__toast-body {\n    font-size: 14px; /* Энд хүссэн хэмжээ */\n  }\n  \n  .input-icon-wrapper {\n    position: relative;\n  }\n  \n  .input-icon {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 20px;\n    width: 20px;\n    color: #888;\n  }\n  \n  .error {\n    color: #e11d48;\n    font-size: 13px;\n    margin-top: 4px;\n  }\n  \n  .error-border {\n    border-color: #e11d48 !important;\n  }\n  \n  .file-drop {\n    border: 2px dashed #ccc;\n    border-radius: 8px;\n    padding: 40px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .file-drop:hover {\n    border-color: #007bff;\n    background: #f0f8ff;\n  }\n  \n  .file-icon {\n    height: 48px;\n    width: 48px;\n    color: #706e6e;\n    margin-bottom: 10px;\n  }\n  \n  .file-text {\n    font-size: 15px;\n    color: #444;\n    margin-bottom: 4px;\n  }\n  \n  .file-note {\n    font-size: 12px;\n    color: #777;\n  }\n  \n  .file-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f8fafc;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 12px 16px;\n  }\n  \n  .file-details {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .file-small-icon {\n    color: #007bff;\n    height: 20px;\n    width: 20px;\n  }\n  \n  .file-name {\n    font-weight: 600;\n    color: #333;\n  }\n  \n  .file-size {\n    font-size: 13px;\n    color: #666;\n  }\n  \n  .file-remove {\n    background: #fee2e2;\n    border: none;\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n  \n  .file-remove:hover {\n    background: #fecaca;\n  }\n  \n  .form-footer {\n    border-top: 1px solid #eee;\n    padding-top: 20px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
